import clsx from 'clsx';
import { FC, ReactNode } from 'react';
import { useInView } from 'react-intersection-observer';
import { twMerge } from 'tailwind-merge';

const InViewWrapper: FC<{ children: ReactNode; className?: string; threshold?: number }> = ({
  children,
  className,
  threshold = 0.3,
}) => {
  const useInViewSettings = { threshold, triggerOnce: true };
  const [viewRef, viewCheck] = useInView(useInViewSettings);

  return (
    <div ref={viewRef} className={twMerge(clsx(className, viewCheck ? 'group inView' : ''))}>
      {children}
    </div>
  );
};

export default InViewWrapper;
